import { render } from "./OrderTabInvoiceHistory.vue?vue&type=template&id=c5cdc986"
import script from "./OrderTabInvoiceHistory.vue?vue&type=script&lang=js"
export * from "./OrderTabInvoiceHistory.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__